import React from 'react';
import BalanceSheetEditAccountSelectInstitutionStepTemplate from 'Views/Page/Content/Modal/Layouts/balanceSheetEditAccountSelectInstitutionStepTemplate/template';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';

export const BalanceSheetEditAccountSelectInstitutionStepDOTemplate = () => {
  const { refreshOnboardingStepCollection } = useSurveyContext();

  return (
    <BalanceSheetEditAccountSelectInstitutionStepTemplate afterOnClickInstitution={() => refreshOnboardingStepCollection()} />
  );
};
